import { render, staticRenderFns } from "./user-org-main.vue?vue&type=template&id=69c4f5cf&"
import script from "./user-org-main.vue?vue&type=script&lang=js&"
export * from "./user-org-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports